import { type ReactElement } from 'react'
import { type AccountId, type AreaId, type CompanyId, type TeamId, type WorkflowId } from '@terros/common'
import { useAccount, useArea, useCompany, useTeam, useWorkflow } from '@front/model'
import { getAccountResultText } from '../account/search/searchResultModel'
import { DetectedIdAction, type DetectedIdActionProps } from './DetectedIdAction'

export const AccountIdItem = ({
  accountId,
  ...props
}: DetectedIdActionProps & { accountId: AccountId }): ReactElement => {
  const query = useAccount(accountId)
  const text = query.data ? getAccountResultText(query.data) : undefined
  return <DetectedIdAction {...props} query={query} name={text?.label} subtitle={text?.details} icon='home' />
}

export const AreaIdItem = ({ areaId, ...props }: DetectedIdActionProps & { areaId: AreaId }): ReactElement => {
  const query = useArea(areaId)
  const name = query.data ? (query.data.name ?? areaId) : undefined
  return <DetectedIdAction {...props} query={query} name={name} icon='map' />
}

export const WorkflowIdItem = ({
  workflowId,
  ...props
}: DetectedIdActionProps & { workflowId: WorkflowId }): ReactElement => {
  const query = useWorkflow(workflowId)
  return <DetectedIdAction {...props} query={query} name={query.data?.name} icon='account_tree' />
}

export const TeamIdItem = ({ teamId, ...props }: DetectedIdActionProps & { teamId: TeamId }): ReactElement => {
  const query = useTeam(teamId)
  return (
    <DetectedIdAction
      {...props}
      query={query}
      name={query.data?.team.name}
      avatarUrl={query.data?.team.avatarUrl}
      icon='groups'
    />
  )
}

export const CompanyIdItem = ({
  companyId,
  ...props
}: DetectedIdActionProps & { companyId: CompanyId }): ReactElement => {
  const query = useCompany({ companyId })
  return (
    <DetectedIdAction
      {...props}
      query={query}
      name={query.data?.name}
      avatarUrl={query.data?.avatarUrl}
      icon='business'
    />
  )
}
